import { schema } from 'normalizr';

const getAccountGOSTransactions = new schema.Entity('accountGOSTransactions');

export default getAccountGOSTransactions;
